import _ from 'utils/@lodash';

const generateGUID = () => {
	const S4 = () => {
		return Math.floor((1 + Math.random()) * 0x10000)
			.toString(16)
			.substring(1);
	}

	return S4() + S4();
}

function NotificationModel(data: any) {
	data = data || {};

	return _.defaults(data, {
		id: generateGUID(),
		message: '',
		options: {
			variant: 'default'
		}
	});
}

export default NotificationModel;
